<div *ngIf="tab.current != null && tab.active && !tabsService.minimizeScreenMode">

  <div [ngClass]="tab.loading? 'active' : ''" class="loading">
    <div></div>
  </div>

  <form #form="ngForm" [ngClass]="[tabsService.fullScreenMode ? 'fullscreen' : '']" autocomplete="off" class="active"
        id="filterForm">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Fields Options</h4>
          <span> </span>
        </div>

        <div class="dropdown-fields">
          <div>
            <label for="it_filter_type">Field</label>
            <select [(ngModel)]="tab.current.field_index" id="it_filter_type" name="filter_type" required>
              <option *ngFor="let filter of tab.current.filters; index as i" value="{{i}}">
                {{filter.display}}</option>
            </select>
          </div>
        </div>

        <div class="input-fields">
          <ng-container *ngFor="let input of tab.current.field_inputs; index as i">
            <div>
              <label [for]="'value_'+i">{{input.field}}</label>

              <ng-container [ngSwitch]="input.type">
                <select *ngSwitchCase="'dropdown'" [id]="'value_'+i" [name]="'value_'+i" required
                        [(ngModel)]="tab.current.field_values[i]">
                  <option *ngFor="let item of input.value()" [value]="item.value">{{ item.display }}</option>
                </select>

                <input *ngSwitchDefault [id]="'value_'+i" [name]="'value_'+i" required [value]="input.value()"
                       [(ngModel)]="tab.current.field_values[i]" [type]="input.type"/>

              </ng-container>
            </div>
          </ng-container>

          <div class="btn">
            <button (click)="this.tab.current.addFilter()" [disabled]="!form.form.valid">Add Filter</button>
          </div>
        </div>
      </div>
    </div>

    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Applied Filters</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <div class="scrollable">
              <table>
                <thead>
                <tr>
                  <th>Field</th>
                  <th scope="col">Value</th>
                </tr>
                </thead>

                <tbody>
                <ng-container *ngFor="let filter of tab.current.addedFilters;">
                  <ng-container *ngFor="let conditions of filter.conditions; index as i">
                    <tr (click)="tab.current.selectFilter(filter.name, i)"
                        [class.highlighted]="tab.current.isSelectedFilter(filter.name, i)">

                      <td>{{ filter.name }}</td>

                      <td>
                        {{getConditionString(filter.name, conditions) }}
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                </tbody>
              </table>
            </div>

            <div class="btn">
              <button (click)="featureFilterService.applyFilterTab(FilterMode.ONLY)">Apply Filter</button>
              <button (click)="tab.current.removeFilter()">Remove Filter</button>
              <button (click)="featureFilterService.applyFilterTab(FilterMode.SELECT)">Select on Map</button>
              <button (click)="featureFilterService.resetFilterTab()">Reset</button>
            </div>
          </div>
        </div>

        <div *ngIf="tab.current.count.total != 0" class="notes">
          Filtering {{ tab.current.count.filtered }} of {{ tab.current.count.total }}.</div>
      </div>
    </div>
  </form>

</div>
